export const HUGG_ENTRADA_PRONTUARIO_TIPOS = [
  'RECEITA',
  'DOCUMENTO'
];
